import Api from '../../Utils/Axios';

export const getUnreadNotificationCount = async () => {
  return new Promise((resolve, reject) => {
    try {
      resolve(Api.get(`/master/notification/unread_count`));
    } catch (error) {
      reject(error);
    }
  });
};
export const getUnreadNotification = async () => {
  return new Promise((resolve, reject) => {
    try {
      resolve(Api.get(`/master/notification/unread?limit=10`));
    } catch (error) {
      reject(error);
    }
  });
};
export const getAllNotification = async (id = '') => {
  return new Promise((resolve, reject) => {
    try {
      let notificationId = '';
      if (id !== '') {
        notificationId = `?notification_id=${id}`;
      }
      resolve(Api.get(`/master/notification/all${notificationId}`));
    } catch (error) {
      reject(error);
    }
  });
};
export const clearAllNotificationListSearvice = async () => {
  return new Promise((resolve, reject) => {
    try {
      resolve(Api.get(`/master/notification/clear_all`));
    } catch (error) {
      reject(error);
    }
  });
};
